export const DataAlberth = [
  {
    'id': 1,
    'name': 'email',
    'description': 'alberth.perez@hotmail.com',
    'url': 'mailto:alberth.perez@hotmail.com?Subject=Estoy%20Interesado%20en%20%20una%Página%20Web'
  },
  {
    'id': 2,
    'name': 'location',
    'description': 'Bogotá, Colombia',
    'url': 'https://www.google.com/maps/place/Bogot%C3%A1/@4.6486259,-74.2478966,11z/data=!3m1!4b1!4m5!3m4!1s0x8e3f9bfd2da6cb29:0x239d635520a33914!8m2!3d4.7109886!4d-74.072092?hl=es'
  },
  {
    'id': 3,
    'name': 'whatsApp',
    'description': '(+57) 322-8107821',
    'url': 'https://api.whatsapp.com/send?phone=573228107821&text=Estoy%20atento%20para%20escribirte' 
  },
  {
    'id': 4,
    'name': 'linkedIn',
    'description': 'https://bit.ly/3kEUUH9',
    'url': 'https://bit.ly/3kEUUH9'
  },
  {
    'id': 5,
    'name': 'instagram',
    'description': 'https://bit.ly/32VoDp6',
    'url': 'https://bit.ly/32VoDp6' 
  },
  {
    'id': 6,
    'name': 'facebook',
    'description': 'https://bit.ly/35grIjO',
    'url': 'https://bit.ly/35grIjO' 
  },
  {
    'id': 7,
    'name': 'twitter',
    'description': 'https://bit.ly/3lRbvs2',
    'url': 'https://bit.ly/3lRbvs2' 
  },
  {
    'id': 8,
    'name': 'gitHub',
    'description': 'https://bit.ly/3lKAFIC',
    'url': 'https://bit.ly/3lKAFIC'
  }
];